import dynamic from 'next/dynamic'

import { useSelectRoadmapModalHandler } from '~entities/roadmap/model'
import Loader from '~lib/ui-kit/Loader'
import Modal from '~lib/ui-kit/Modal'
import Space from '~lib/ui-kit/Space'

/* eslint-disable import/prefer-default-export */

const SelectRoadmapForm = dynamic(() => import('./SelectRoadmapForm'), {
  loading: () => (
    <Space align="center" justify="center">
      <Loader />
    </Space>
  ),
})

export const SelectRoadmapModal = () => {
  const { state, close } = useSelectRoadmapModalHandler()
  return (
    <>
      <Modal
        opened={state.opened}
        overlayVariant="blur"
        showCloseButton
        size="s"
        onClose={close}
        onEscapePress={close}
        onOverlayClick={close}
      >
        <SelectRoadmapForm onClose={close} onSelect={state?.onSelect} />
      </Modal>
    </>
  )
}
